// Vendors
import './vendors/bootstrap';
import './vendors/jquery.suggest';
import {initLazyLoad} from './vendors/lazyload';
import {aosInit} from "./vendors/aosInit";

// Layout
import {initOffcanvasToggling, initProgressBullet} from './layout/header';

// Components
import {addAccordionClass} from './components/accordion';
import {changeButtonFile} from './components/button-file';
//Calc functions
import {fetchData} from "./components/calculator/fetchData";
import {
    CalculatorContext,
    generateCalculatorFields,
    generatePreviewCalculatorFields,
} from './components/calculator/calculatorFields';
import {calcInit} from './components/calculator/calculator';
import {prevCalcInit} from './components/calculator/previewCalculator';

import {selectAllCheckbox} from './components/select-all';
import {wrapTable} from './components/table';
import {selectInit} from './components/select';
import {toggleConsent} from './components/lp-forms/consent';
import {handleSingleForm} from './components/lp-forms/lp-forms';

// Others
import {initCounterAnimation} from './other/counter-animation'
import {enableBtn} from './other/enable-button'
import {stopVideo} from './other/stop-video'
import {initFloatingButton} from './other/floatingButton'

const $ = jQuery;

export const apiDomain = apiSettings.apiDomain;

// Invokes on document ready
$(function () {
    initLazyLoad?.();
    initOffcanvasToggling?.();
    addAccordionClass?.();
    changeButtonFile?.();
    selectAllCheckbox?.();
    initProgressBullet?.();

    /*** Calculator functions start ***/
    // Endpoint URL
    /* global apiSettings */
    const mainCalc = document.getElementById('calculator');
    const secondCalc = document.querySelector('.two-calcs');
    const previewCalc = document.getElementById('preview-calculator');
    const siteUrl = apiSettings.site_url;
    // Get endpoints from fields set in WP admin panel for specific page.
    // If fields are blank use default endpoint.
    let epConfigurationCalc = apiSettings.calc_1_endpoint ? apiSettings.calc_1_endpoint : apiDomain + '/loan-calculator/configuration/v2';
    let epConfigurationCalcPromo = apiSettings.calc_2_endpoint ? apiSettings.calc_2_endpoint : apiDomain + '/loan-calculator/configuration_promo/v2';
    let epConfigurationCalcOld = apiSettings.calc_3_endpoint ? apiSettings.calc_3_endpoint : apiDomain + '/loan-calculator/current-configuration';

    const defaultValueBig = apiSettings.default_value_big;
    const defaultValueBig2 = apiSettings.default_value_big_2;
    // Get steps from fields set in WP admin panel for specific page.
    const calcAmountSteps = apiSettings.calc_amount_steps;
    // Get settings for calc (PROMO)
    const calcSettings = apiSettings.calc_settings;

    if (previewCalc) {
        fetchData(epConfigurationCalcOld)
            .then(data => {
                if (data) {
                    /**
                     * Preview calc
                     */
                    if (previewCalc) {
                        generatePreviewCalculatorFields().then(fields => {
                            const previewContext = new CalculatorContext(data.data, fields);
                            prevCalcInit?.(previewCalc, siteUrl, apiDomain, previewContext);
                        }).catch(error => {
                            console.error('Error generating preview calculator fields:', error);
                        });
                    }
                }
            });
    }

    if (mainCalc) {
        fetchData(epConfigurationCalc)
            .then(data => {
                if (data) {
                    /**
                     * Default calc
                     */
                    if (mainCalc) {
                        const mainContext = new CalculatorContext(data, generateCalculatorFields(0));
                        calcInit?.(mainCalc, siteUrl, apiDomain, mainContext, defaultValueBig, calcAmountSteps, calcSettings, epConfigurationCalc);
                    }
                }
            });
    }

    if (mainCalc && secondCalc) {
        fetchData(epConfigurationCalcPromo)
            .then(data => {
                if (data) {
                    const mainContext2 = new CalculatorContext(data, generateCalculatorFields(1));
                    calcInit?.(mainCalc, siteUrl, apiDomain, mainContext2, defaultValueBig2, calcAmountSteps, calcSettings, epConfigurationCalcPromo);
                }
            });
    }
    /*** Calculator functions end ***/

    enableBtn?.();
    selectInit?.();
    wrapTable?.();
    stopVideo?.();
    initCounterAnimation?.();
    initFloatingButton?.();

    const form = document.getElementById('lp-form');
    if (form) {
        const popupId = apiSettings.popup_id;

        handleSingleForm?.(form, popupId);
        toggleConsent?.();
    }

    // Init AOS animations
    aosInit();
});
